/**
 * Stable public URLs for the Shams mark and survey photography extracted
 * from the Word report master (`templates/Report Template/WORD/…docx`).
 * Import these constants instead of guessing filenames.
 * Floor plans and analytical certificates stay out of `public/`.
 */
export const BRAND_ASSETS = {
  mark: "/brand/mark.png",
  mark32: "/brand/mark-32.png",
  appleTouch: "/brand/apple-touch.png",
  faviconPng: "/favicon.png",
  surveyor: "/media/surveyor.jpg",
  premises: "/media/premises.jpg",
  texturedCoating: "/media/textured-coating.jpg",
  loftFelt: "/media/loft-felt.jpg",
  cementTiles: "/media/cement-tiles.jpg",
} as const;

export type BrandAssetPath = (typeof BRAND_ASSETS)[keyof typeof BRAND_ASSETS];
